import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { buttonReset } from '../styles/theme';
import { toggleVideoSound } from '../actions';
import { isSoundMuted } from '../selectors';
import AudioIcon from './AudioIcon';

const ToggleAudioButton = ({
  busy, classes, className, onClick,
  muted, showText,
}) => (
  <button
    disabled={busy}
    className={cn(classes.toggleAudio, className)}
    onClick={onClick(muted)}
    type="button"
  >
    <AudioIcon muted={muted} className={classes.audioIcon} />
    {showText && (
      <span className={classes.text}>
        Sound
        {' '}
        {muted ? 'off' : 'on'}
      </span>
    )}
  </button>
);

ToggleAudioButton.propTypes = {
  busy: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  muted: PropTypes.bool,
  showText: PropTypes.bool,
};

ToggleAudioButton.defaultProps = {
  busy: false,
  className: undefined,
  onClick: undefined,
  muted: true,
  showText: true,
};

const mapStateToProps = state => ({
  muted: isSoundMuted(state),
});

const mapDispatchToProps = dispatch => ({
  onClick: muted => e => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(toggleVideoSound(!muted));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet({
    toggleAudio: {
      ...buttonReset({
        fontFamily: theme.fonts.bold,
        fontWeight: theme.fonts.boldWeight,
        fontSize: 11,
        textAlign: 'left',
        textTransform: 'uppercase',
        letterSpacing: 2.3,
        textDecoration: 'none !important',
        padding: 16,
        lineHeight: '25px',
        color: theme.colors.white,
        position: 'absolute',
        zIndex: 1,
        [theme.breakpoints.wideMobile]: {
          fontSize: 12,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 16,
        },
      }),
      cursor: 'pointer',
      display: 'flex',
      height: 55,
      [theme.breakpoints.up('md')]: {
        height: 57,
      },
      '& > *': {
        pointerEvents: 'none',
      },
    },
    text: {
      position: 'relative',
      top: 4,
      display: ({ contentType }) => (contentType === 'header_1' && 'none'),
      [theme.breakpoints.up('md')]: {
        display: ({ contentType }) => (contentType === 'header_1' && 'inline-block'),
      },
    },
    audioIcon: {
      height: 23,
      verticalAlign: 'bottom',
      [theme.breakpoints.up('md')]: {
        height: 25,
      },
    },
  }),
)(ToggleAudioButton);
